var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"zone",staticClass:"eui-o-signPDFViewer__zone eui-u-flex -initialZone",style:(_vm.styleObject)},[(_vm.$slots.default)?_c('div',{staticClass:"eui-o-signPDFViewer__text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }